import gql from "graphql-tag";

export const LOCK_USER_QUERY = gql`
  mutation LockUserMutation($id: ID!, $locked: Boolean!) {
    setUserLocked(where: { id: $id }, locked: $locked) {
      id
      lockedAt
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mutations/LockUser/queries.ts